<template>
  <div class="packages">
    <div class="page-header">
      <h2>包管理</h2>
      <p>查看和管理包信息</p>
    </div>
    
    <div class="page-content">
      <el-form :inline="true" style="margin-bottom: 12px;">
        <el-form-item label="关键词：">
          <el-input v-model="keyword" placeholder="包名/分包编号/项目/单位" clearable style="width: 260px;" @keyup.enter.native="onSearch" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSearch">查询</el-button>
          <el-button @click="onReset">重置</el-button>
        </el-form-item>
      </el-form>
      <el-table
        :data="treeData"
        v-loading="loading"
        row-key="rowKey"
        :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
        :default-expand-all="true"
        style="width: 100%">
        <el-table-column prop="package_name" label="包名称" min-width="200">
          <template slot-scope="scope">
            <span v-if="scope.row.isMainPackage">
              {{ scope.row.package_name }}
              <el-button 
                type="text" 
                size="small" 
                icon="el-icon-edit" 
                @click="handleEditPackageName(scope.row)"
                style="margin-left: 8px;">
                编辑
              </el-button>
            </span>
            <span v-else>
              {{ scope.row.sub_package_name }}
              <el-button 
                type="text" 
                size="small" 
                icon="el-icon-edit" 
                @click="handleEditSubPackageName(scope.row)"
                style="margin-left: 8px;">
                编辑
              </el-button>
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="sub_package_no" label="分包编号" width="160">
          <template slot-scope="scope">
            <span v-if="!scope.row.isMainPackage">
              {{ scope.row.sub_package_no }}
              <el-button 
                type="text" 
                size="small" 
                icon="el-icon-edit" 
                @click="handleEditSubPackageNo(scope.row)"
                style="margin-left: 8px;">
                编辑
              </el-button>
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="quantity" label="采购数量" width="180">
          <template slot-scope="scope">
            <span v-if="scope.row.isMainPackage">-</span>
            <span v-else>
              {{ scope.row.quantity }}
              <el-button 
                type="text" 
                size="small" 
                icon="el-icon-edit" 
                @click="handleEditQuantity(scope.row)"
                style="margin-left: 8px;">
                编辑
              </el-button>
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="percentage" label="百分比" width="150">
          <template slot-scope="scope">
            <span v-if="scope.row.isMainPackage">
              {{ scope.row.percentage }}%
              <el-button 
                type="text" 
                size="small" 
                icon="el-icon-edit" 
                @click="handleEditPercentage(scope.row)"
                style="margin-left: 8px;">
                编辑
              </el-button>
            </span>
            <span v-else-if="scope.row.percentage !== undefined">{{ scope.row.percentage }}%</span>
          </template>
        </el-table-column>
        <el-table-column prop="all_average_price" label="所有均价" width="140">
          <template slot-scope="scope">
            <span v-if="scope.row.all_average_price !== undefined">¥{{ Number(scope.row.all_average_price).toFixed(2) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="valid_average_price" label="有效均价" width="140">
          <template slot-scope="scope">
            <span v-if="scope.row.valid_average_price !== undefined">¥{{ Number(scope.row.valid_average_price).toFixed(2) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="base_price" label="基准价" width="140">
          <template slot-scope="scope">
            <span v-if="scope.row.base_price !== undefined">¥{{ Number(scope.row.base_price).toFixed(2) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="unit_name" label="项目单位" min-width="200">
          <template slot-scope="scope">
            <span v-if="scope.row.isMainPackage">{{ scope.row.unit_name }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="created_at" label="创建时间" width="180">
          <template slot-scope="scope">
            <span v-if="!scope.row.isMainPackage">{{ scope.row.created_at }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="120" fixed="right">
          <template slot-scope="scope">
            <el-button
              v-if="scope.row.isMainPackage"
              type="danger"
              size="small"
              icon="el-icon-delete"
              @click="handleDelete(scope.row)">
              删除
            </el-button>
            <el-button
              v-else
              type="danger"
              size="small"
              icon="el-icon-delete"
              @click="handleDeleteSubPackage(scope.row)">
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      
      <div style="margin-top: 20px; text-align: center;">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-size="pageSize"
          :total="packagesTotal"
          layout="prev, pager, next, total">
        </el-pagination>
      </div>
    </div>
    
    <!-- 编辑百分比对话框 -->
    <el-dialog
      title="编辑主包百分比"
      :visible.sync="editDialogVisible"
      width="400px"
      @close="handleEditDialogClose">
      <el-form :model="editForm" label-width="100px">
        <el-form-item label="主包名称：">
          <span>{{ editForm.package_name }}</span>
        </el-form-item>
        <el-form-item label="当前百分比：">
          <span>{{ editForm.old_percentage }}%</span>
        </el-form-item>
        <el-form-item label="新百分比：" required>
          <el-input-number
            v-model="editForm.percentage"
            :min="0"
            :max="100"
            :precision="2"
            style="width: 100%;"
            placeholder="请输入百分比">
            <template slot="append">%</template>
          </el-input-number>
        </el-form-item>
        <el-form-item>
          <el-alert
            title="提示"
            type="info"
            :closable="false"
            show-icon>
            <template slot="default">
              修改百分比后，系统将自动重新计算该主包下所有分包的价格指标和投标记录的价格分。
            </template>
          </el-alert>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="editDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSavePercentage" :loading="saving">确定</el-button>
      </div>
    </el-dialog>
    
    <!-- 编辑采购数量对话框 -->
    <el-dialog
      title="编辑分包采购数量"
      :visible.sync="editQuantityDialogVisible"
      width="400px"
      @close="handleEditQuantityDialogClose">
      <el-form :model="editQuantityForm" label-width="100px">
        <el-form-item label="分包名称：">
          <span>{{ editQuantityForm.sub_package_name }}</span>
        </el-form-item>
        <el-form-item label="分包编号：">
          <span>{{ editQuantityForm.sub_package_no }}</span>
        </el-form-item>
        <el-form-item label="当前数量：">
          <span>{{ editQuantityForm.old_quantity }}</span>
        </el-form-item>
        <el-form-item label="新数量：" required>
          <el-input-number
            v-model="editQuantityForm.quantity"
            :min="1"
            :precision="0"
            style="width: 100%;"
            placeholder="请输入采购数量">
          </el-input-number>
        </el-form-item>
        <el-form-item>
          <el-alert
            title="提示"
            type="info"
            :closable="false"
            show-icon>
            <template slot="default">
              修改采购数量后，系统将自动重新计算该分包的价格指标和投标记录的价格分。
            </template>
          </el-alert>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="editQuantityDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSaveQuantity" :loading="savingQuantity">确定</el-button>
      </div>
    </el-dialog>
    
    <!-- 删除主包确认对话框 -->
    <el-dialog
      title="删除主包"
      :visible.sync="deleteDialogVisible"
      width="500px">
      <el-alert
        title="警告"
        type="warning"
        :closable="false"
        show-icon
        style="margin-bottom: 20px;">
        <template slot="default">
          删除主包将同时删除该主包下的所有分包和投标记录，此操作不可恢复！
        </template>
      </el-alert>
      <el-form :model="deleteForm" label-width="100px">
        <el-form-item label="主包名称：">
          <span style="font-weight: bold; color: #F56C6C;">{{ deleteForm.package_name }}</span>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="deleteDialogVisible = false">取消</el-button>
        <el-button type="danger" @click="handleConfirmDelete" :loading="deleting">确认删除</el-button>
      </div>
    </el-dialog>
    
    <!-- 删除分包确认对话框 -->
    <el-dialog
      title="删除分包"
      :visible.sync="deleteSubPackageDialogVisible"
      width="500px">
      <el-alert
        title="警告"
        type="warning"
        :closable="false"
        show-icon
        style="margin-bottom: 20px;">
        <template slot="default">
          删除分包将同时删除该分包下的所有投标记录，此操作不可恢复！
        </template>
      </el-alert>
      <el-form :model="deleteSubPackageForm" label-width="100px">
        <el-form-item label="分包名称：">
          <span style="font-weight: bold; color: #F56C6C;">{{ deleteSubPackageForm.sub_package_name }}</span>
        </el-form-item>
        <el-form-item label="分包编号：">
          <span style="font-weight: bold; color: #F56C6C;">{{ deleteSubPackageForm.sub_package_no }}</span>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="deleteSubPackageDialogVisible = false">取消</el-button>
        <el-button type="danger" @click="handleConfirmDeleteSubPackage" :loading="deletingSubPackage">确认删除</el-button>
      </div>
    </el-dialog>
    
    <!-- 编辑主包名称对话框 -->
    <el-dialog
      title="编辑主包名称"
      :visible.sync="editPackageNameDialogVisible"
      width="400px"
      @close="handleEditPackageNameDialogClose">
      <el-form :model="editPackageNameForm" label-width="100px">
        <el-form-item label="主包名称：" required>
          <el-input
            v-model="editPackageNameForm.package_name"
            placeholder="请输入主包名称"
            maxlength="255"
            show-word-limit>
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="editPackageNameDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSavePackageName" :loading="savingPackageName">确定</el-button>
      </div>
    </el-dialog>
    
    <!-- 编辑分包信息对话框 -->
    <el-dialog
      title="编辑分包信息"
      :visible.sync="editSubPackageInfoDialogVisible"
      width="400px"
      @close="handleEditSubPackageInfoDialogClose">
      <el-form :model="editSubPackageInfoForm" label-width="100px">
        <el-form-item label="分包名称：" required>
          <el-input
            v-model="editSubPackageInfoForm.sub_package_name"
            placeholder="请输入分包名称"
            maxlength="255"
            show-word-limit>
          </el-input>
        </el-form-item>
        <el-form-item label="分包编号：" required>
          <el-input
            v-model="editSubPackageInfoForm.sub_package_no"
            placeholder="请输入分包编号"
            maxlength="100"
            show-word-limit>
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="editSubPackageInfoDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSaveSubPackageInfo" :loading="savingSubPackageInfo">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'Packages',
  data() {
    return {
      loading: false,
      currentPage: 1,
      pageSize: 10,
      keyword: '',
      editDialogVisible: false,
      saving: false,
      editForm: {
        id: null,
        package_name: '',
        old_percentage: 0,
        percentage: 0
      },
      editQuantityDialogVisible: false,
      savingQuantity: false,
      editQuantityForm: {
        id: null,
        sub_package_name: '',
        sub_package_no: '',
        old_quantity: 0,
        quantity: 0
      },
      deleteDialogVisible: false,
      deleting: false,
      deleteForm: {
        id: null,
        package_name: ''
      },
      deleteSubPackageDialogVisible: false,
      deletingSubPackage: false,
      deleteSubPackageForm: {
        id: null,
        sub_package_name: '',
        sub_package_no: ''
      },
      editPackageNameDialogVisible: false,
      savingPackageName: false,
      editPackageNameForm: {
        id: null,
        package_name: ''
      },
      editSubPackageInfoDialogVisible: false,
      savingSubPackageInfo: false,
      editSubPackageInfoForm: {
        id: null,
        sub_package_name: '',
        sub_package_no: ''
      }
    }
  },
  computed: {
    ...mapState(['packages', 'packagesTotal']),
    // 将扁平数据转换为树形结构
    treeData() {
      if (!this.packages || this.packages.length === 0) {
        return []
      }
      
      // 使用 Map 来存储主包，key 是 package_id
      const packageMap = new Map()
      
      // 遍历所有数据，按主包分组
      this.packages.forEach(item => {
        const packageId = item.id // 主包ID
        const subPackageId = item.sub_package_id // 分包ID
        
        // 如果主包不存在，创建主包节点
        if (!packageMap.has(packageId)) {
          packageMap.set(packageId, {
            rowKey: `package_${packageId}`,
            isMainPackage: true,
            id: packageId,
            package_name: item.package_name,
            percentage: item.percentage,
            unit_name: item.unit_name,
            project_id: item.project_id,
            children: []
          })
        }
        
        // 添加分包作为子节点
        const mainPackage = packageMap.get(packageId)
        mainPackage.children.push({
          rowKey: `subpackage_${subPackageId}`,
          isMainPackage: false,
          id: subPackageId,
          package_id: packageId,
          sub_package_name: item.sub_package_name,
          sub_package_no: item.sub_package_no,
          quantity: item.quantity,
          percentage: item.percentage,
          all_average_price: item.all_average_price,
          valid_average_price: item.valid_average_price,
          base_price: item.base_price,
          created_at: item.created_at,
          unit_name: item.unit_name
        })
      })
      
      // 转换为数组并排序
      return Array.from(packageMap.values()).sort((a, b) => {
        // 可以按创建时间或其他字段排序
        return a.id - b.id
      })
    }
  },
  mounted() {
    this.loadData()
  },
  methods: {
    ...mapActions(['loadPackages']),
    
    async loadData() {
      this.loading = true
      try {
        await this.loadPackages({
          page: this.currentPage,
          size: this.pageSize,
          keyword: this.keyword
        })
      } finally {
        this.loading = false
      }
    },
    
    handleCurrentChange(page) {
      this.currentPage = page
      this.loadData()
    },
    onSearch() {
      this.currentPage = 1
      this.loadData()
    },
    onReset() {
      this.keyword = ''
      this.currentPage = 1
      this.loadData()
    },
    
    handleEditPercentage(row) {
      this.editForm = {
        id: row.id,
        package_name: row.package_name,
        old_percentage: row.percentage || 0,
        percentage: row.percentage || 0
      }
      this.editDialogVisible = true
    },
    
    handleEditDialogClose() {
      this.editForm = {
        id: null,
        package_name: '',
        old_percentage: 0,
        percentage: 0
      }
    },
    
    async handleSavePercentage() {
      if (this.editForm.percentage < 0 || this.editForm.percentage > 100) {
        this.$message.error('百分比必须在0-100之间')
        return
      }
      
      this.saving = true
      try {
        const response = await this.$http.put(`/import/packages/${this.editForm.id}/percentage`, {
          percentage: this.editForm.percentage
        })
        
        if (response.data.code === 0 && response.data.data && response.data.data.success) {
          this.$message.success('更新成功，正在重新计算分包数据...')
          this.editDialogVisible = false
          // 刷新数据
          await this.loadData()
          this.$message.success('数据已更新')
        } else {
          const message = (response.data.data && response.data.data.message) || '更新失败'
          this.$message.error(message)
        }
      } catch (error) {
        console.error('更新百分比失败:', error)
        const message = (error.response && error.response.data && error.response.data.data && error.response.data.data.message) || '更新失败'
        this.$message.error(message)
      } finally {
        this.saving = false
      }
    },
    
    handleEditQuantity(row) {
      this.editQuantityForm = {
        id: row.id,
        sub_package_name: row.sub_package_name,
        sub_package_no: row.sub_package_no,
        old_quantity: row.quantity || 0,
        quantity: row.quantity || 0
      }
      this.editQuantityDialogVisible = true
    },
    
    handleEditQuantityDialogClose() {
      this.editQuantityForm = {
        id: null,
        sub_package_name: '',
        sub_package_no: '',
        old_quantity: 0,
        quantity: 0
      }
    },
    
    async handleSaveQuantity() {
      if (this.editQuantityForm.quantity < 1) {
        this.$message.error('采购数量必须大于0')
        return
      }
      
      this.savingQuantity = true
      try {
        const response = await this.$http.put(`/import/sub-packages/${this.editQuantityForm.id}/quantity`, {
          quantity: this.editQuantityForm.quantity
        })
        
        if (response.data.code === 0 && response.data.data && response.data.data.success) {
          this.$message.success('更新成功，正在重新计算价格数据...')
          this.editQuantityDialogVisible = false
          // 刷新数据
          await this.loadData()
          this.$message.success('数据已更新')
        } else {
          const message = (response.data.data && response.data.data.message) || '更新失败'
          this.$message.error(message)
        }
      } catch (error) {
        console.error('更新采购数量失败:', error)
        const message = (error.response && error.response.data && error.response.data.data && error.response.data.data.message) || '更新失败'
        this.$message.error(message)
      } finally {
        this.savingQuantity = false
      }
    },
    
    handleDelete(row) {
      this.deleteForm.id = row.id
      this.deleteForm.package_name = row.package_name
      this.deleteDialogVisible = true
    },
    
    async handleConfirmDelete() {
      this.deleting = true
      try {
        const response = await this.$http.delete(`/import/packages/${this.deleteForm.id}`)
        
        if (response.data.code === 0 || response.data.success) {
          this.$message.success('删除成功')
          this.deleteDialogVisible = false
          this.loadData()
        } else {
          const message = response.data.message || (response.data.data && response.data.data.message) || '删除失败'
          this.$message.error(message)
        }
      } catch (error) {
        console.error('删除失败:', error)
        const message = (error.response && error.response.data && error.response.data.data && error.response.data.data.message) || 
                       (error.response && error.response.data && error.response.data.message) || 
                       '删除失败'
        this.$message.error(message)
      } finally {
        this.deleting = false
      }
    },
    
    handleDeleteSubPackage(row) {
      this.deleteSubPackageForm.id = row.id
      this.deleteSubPackageForm.sub_package_name = row.sub_package_name
      this.deleteSubPackageForm.sub_package_no = row.sub_package_no
      this.deleteSubPackageDialogVisible = true
    },
    
    async handleConfirmDeleteSubPackage() {
      this.deletingSubPackage = true
      try {
        const response = await this.$http.delete(`/import/sub-packages/${this.deleteSubPackageForm.id}`)
        
        if (response.data.code === 0 || response.data.success) {
          this.$message.success('删除成功')
          this.deleteSubPackageDialogVisible = false
          this.loadData()
        } else {
          const message = response.data.message || (response.data.data && response.data.data.message) || '删除失败'
          this.$message.error(message)
        }
      } catch (error) {
        console.error('删除失败:', error)
        const message = (error.response && error.response.data && error.response.data.data && error.response.data.data.message) || 
                       (error.response && error.response.data && error.response.data.message) || 
                       '删除失败'
        this.$message.error(message)
      } finally {
        this.deletingSubPackage = false
      }
    },
    
    handleEditPackageName(row) {
      this.editPackageNameForm.id = row.id
      this.editPackageNameForm.package_name = row.package_name
      this.editPackageNameDialogVisible = true
    },
    
    handleEditPackageNameDialogClose() {
      this.editPackageNameForm = {
        id: null,
        package_name: ''
      }
    },
    
    async handleSavePackageName() {
      if (!this.editPackageNameForm.package_name || this.editPackageNameForm.package_name.trim() === '') {
        this.$message.warning('请输入主包名称')
        return
      }
      
      this.savingPackageName = true
      try {
        const response = await this.$http.put(`/import/packages/${this.editPackageNameForm.id}/name`, {
          package_name: this.editPackageNameForm.package_name.trim()
        })
        
        if (response.data.code === 0 || (response.data.data && response.data.data.success)) {
          this.$message.success('更新成功')
          this.editPackageNameDialogVisible = false
          this.loadData()
        } else {
          const message = (response.data.data && response.data.data.message) || '更新失败'
          this.$message.error(message)
        }
      } catch (error) {
        console.error('更新主包名称失败:', error)
        const message = (error.response && error.response.data && error.response.data.data && error.response.data.data.message) || 
                       (error.response && error.response.data && error.response.data.message) || 
                       '更新失败'
        this.$message.error(message)
      } finally {
        this.savingPackageName = false
      }
    },
    
    handleEditSubPackageName(row) {
      this.editSubPackageInfoForm.id = row.id
      this.editSubPackageInfoForm.sub_package_name = row.sub_package_name
      this.editSubPackageInfoForm.sub_package_no = row.sub_package_no
      this.editSubPackageInfoDialogVisible = true
    },
    
    handleEditSubPackageNo(row) {
      this.editSubPackageInfoForm.id = row.id
      this.editSubPackageInfoForm.sub_package_name = row.sub_package_name
      this.editSubPackageInfoForm.sub_package_no = row.sub_package_no
      this.editSubPackageInfoDialogVisible = true
    },
    
    handleEditSubPackageInfoDialogClose() {
      this.editSubPackageInfoForm = {
        id: null,
        sub_package_name: '',
        sub_package_no: ''
      }
    },
    
    async handleSaveSubPackageInfo() {
      if (!this.editSubPackageInfoForm.sub_package_name || this.editSubPackageInfoForm.sub_package_name.trim() === '') {
        this.$message.warning('请输入分包名称')
        return
      }
      
      if (!this.editSubPackageInfoForm.sub_package_no || this.editSubPackageInfoForm.sub_package_no.trim() === '') {
        this.$message.warning('请输入分包编号')
        return
      }
      
      this.savingSubPackageInfo = true
      try {
        const response = await this.$http.put(`/import/sub-packages/${this.editSubPackageInfoForm.id}/info`, {
          sub_package_name: this.editSubPackageInfoForm.sub_package_name.trim(),
          sub_package_no: this.editSubPackageInfoForm.sub_package_no.trim()
        })
        
        if (response.data.code === 0 || (response.data.data && response.data.data.success)) {
          this.$message.success('更新成功')
          this.editSubPackageInfoDialogVisible = false
          this.loadData()
        } else {
          const message = (response.data.data && response.data.data.message) || '更新失败'
          this.$message.error(message)
        }
      } catch (error) {
        console.error('更新分包信息失败:', error)
        const message = (error.response && error.response.data && error.response.data.data && error.response.data.data.message) || 
                       (error.response && error.response.data && error.response.data.message) || 
                       '更新失败'
        this.$message.error(message)
      } finally {
        this.savingSubPackageInfo = false
      }
    }
  }
}
</script>

<style scoped>
.page-header {
  margin-bottom: 20px;
}

.page-header h2 {
  margin: 0 0 10px 0;
  color: #303133;
}

.page-header p {
  margin: 0;
  color: #909399;
}
</style>
